import text from "./text";
import upload from "./upload";

export default {
  text,
  upload
};
